<template>
  <section class="infos">
    <div class="avatar">
      <img :src="userInfo.avatar" alt="">
      <span>{{ userInfo.username }}</span>
    </div>
    <div class="content">
      <p>UID：{{ userInfo.user_id || '-' }}</p>
      <!-- <p>邮箱：{{ userInfo.email || '-' }}</p> -->
      <p>积分：{{ userInfo.score || 0 }}</p>
      <!-- <p>金币：0</p> -->
    </div>

    <!-- <div class="other">
      <p>邀请链接：{{ invitationLink}}</p>
    </div> -->
  </section>
</template>

<script>
import utils from '@/utils'
export default {
  data () {
    return {
      invitationLink: '-'
    };
  },

  components: {},

  computed: {
    userInfo() {
      return utils.getUserInfo()
    }
  },

  methods: {
    // 生成邀请
    async createInvite(){
      let res=await this.$api.createInvite()
      this.invitationLink=res
    }
  },

  mounted() {
    // this.createInvite()
  }
}

</script>
<style lang='scss' scoped>
.infos{
  width: 100%;
  // height: 100%;
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  color: #242f42;
  .avatar{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
    img{
      width: 100px;
      border-radius: 50%;
      margin-bottom: 10px;
    }
  }

  .content{
    p{
      margin-bottom: 10px;
    }
  }
  .other{

  }

}
</style>